<template>
  <div
    :class="[
      't-label',
      `t-label_color-${color}`,
      `t-label_size-${size}`
    ]"
  >
    <slot />

    <CloseButton
      @click="$emit('close')"
      :class="[
        't-label__close-button',
        { enabled: showCloseButton }
      ]"
    />
  </div>
</template>

<script>
import CloseButton from '@/components/buttons/CloseButton.vue';

export default {
  name: 'TLabel',
  props: {
    color: {
      type: String,
      default: 'gray',
      validator(value) {
        return [
          'light',
          'dark',
          'gray',
          'success',
          'warning',
          'error',
        ].includes(value);
      },
    },
    size: {
      type: String,
      default: 'default',
      validator(value) {
        return [
          'default',
          'small',
        ].includes(value);
      },
    },
    showCloseButton: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CloseButton,
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/mixins";

.t-label {
  display: inline-flex;
  align-items: center;

  @include font-xs();

  border-radius: 100px;
  cursor: default;

  &_color {
    &-light {
      background-color: var(--light);
    }

    &-dark {
      color: var(--light);
      background-color: var(--gray-1);
    }

    &-gray {
      background-color: var(--menu);
    }

    &-success {
      color: var(--light);
      background-color: var(--green-2);
    }

    &-warning {
      background-color: var(--tag);
    }

    &-error {
      color: var(--background);
      background-color: var(--accent);
    }
  }

  &_size {
    &-default {
      padding: 8px 12px;
    }
    &-small {
      padding: 4px 8px;
    }
  }

  &__close-button {
    height: 18px;
    width: 18px;
    margin-left: 8px;
    display: none;
    cursor: pointer;

    &.enabled {
      display: block;
    }
  }
}
</style>
